<template>
  <div v-swiper="swiperOption">
    <div class="swiper-wrapper">
      <slot />
    </div>

    <div class="swiper-pagination" />
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  directives: {
    swiper: directive
  },

  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 8000,
          loop: true,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  }
};
</script>
